export const getColumnFilterValues = ({
  rows = [],
  field,
  statusOptions = [],
}) => {
  if (!field) return []

  const values = [
    ...new Set(
      rows
        .map((row) => row?.[field])
        .filter((v) => v !== null && v !== undefined)
    ),
  ]
  if (field === 'companyStatus') {
    return values.map((val) => {
      const status = statusOptions.find((s) => s.value === val)
      return {
        label: status?.name || 'Unknown',
        value: val,
      }
    })
  }

  return values
}

export const normalizeStatusKey = (value) => {
  if (value == null) return null
  return String(value)
    .trim()
    .toLowerCase()
    .replace(/[_\s]+/g, '')
}